export enum MessageResult {
  None,
  Ok,
  Cancel,
  Yes,
  No
}
